import { render } from "./laundry-timeslot.vue?vue&type=template&id=2e9358a5"
import script from "./laundry-timeslot.vue?vue&type=script&lang=js"
export * from "./laundry-timeslot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__